import { connect } from "react-redux";
import { resolveChildren } from "../../utils/containerUtils";

//Container component allowing its children to bind to another widget
//all children will behave as if part of another widget
//actions will be executed in the context of a different widget
//Switches its widgetId and the widgetId for all its children
//options: config.bindToWidget
//has no data, has no markup
export const WidgetPortal = (props) => {
        return resolveChildren(props);
}

export default connect(
    //mapStateToProps
    (state, props) => ({}),
    //mapDispatchToProps
    null,
    //mergeProps
    //changing props.widgetId for all children components
    (state, dispatchProps, ownProps) => {
        return Object.assign({}, ownProps, {
            widgetId: ownProps.config ? ownProps.config.bindToWidget : ""
        });
    }
)(WidgetPortal);
